module.exports = __webpack_public_path__ + "static/media/en-tracing-shot-2.0eeb50cf.png";